<template>

<div>
    
    <div class="responsive-project-title d-flex justify-content-between align-items-center">
        <h6>Етапи на проекта</h6>
        <span id="close-timeline" class="close-timeline icon icon-x" @click="$parent.isOpen = !$parent.isOpen"></span>
    </div>

    <div v-if='isReady' class="project-timeline" id="project-timeline">

        <ol>
            <li class="step-finished">

                <span class="timeline-step">
                    <span class="icon icon-check"></span>
                </span>

                <h4 :class='["timeline-item", { active : $parent.page == "index" }]'>
                    <span @click='$parent.setPage("index", true)' class="close-timeline">Обща информация</span>
                    
                    <span title="Какво е това?" class="open-desc collapsed" data-toggle="collapse" 
                    href="#etap1" role="button" aria-expanded="false" aria-controls="etap1">
                        <span class="icon-plus-circle"></span>
                        <span class="icon-minus-circle"></span>
                    </span>
                </h4>

                <div class="collapse timeline-item-desc" id="etap1">
                    Тук е заданието на проекта, което след публикуване на проекта не може да се 
                    редактира с цел равни условия за всички участници.
                </div>

                <span class="date">Старт: {{ dateOnly($parent.model.created_at) }}</span>

                <span @click='$parent.setPage("index")' 
                    :class='["vue-link box", { active : $parent.page == "index"}]' >
                        <span class="text close-timeline">Виж този етап</span>
                        <span class="icon icon-after icon-chevron-right"></span>
                </span>

                <ul class="sub-timeline">

                    <li @click='$parent.setPage("messages")' :class='["nav-link box close-timeline", { active : $parent.page == "messages"}]'>
                        <span class="icon-message-square"></span>
                        Въпроси & отговори
                        <span class="badge badge-warning">{{ $parent.messages }}</span>
                    </li>

                    <li @click='$parent.setPage("files")' :class='["nav-link box close-timeline", { active : $parent.page == "files"}]'>
                        <span class="icon-folder"></span>                 
                        Всички файлове
                        <span class="badge badge-warning">{{ $parent.files }}</span>
                    </li>

                </ul>
            </li>

            <li v-for='(phase,i) in phases' :class="[ getPhaseClass(phase), { currentphase : currentPhase.id == phase.id } ]">

                <span class="timeline-step">
                    <img v-if='currentPhase.id == phase.id' src="/resources/images/spinner.svg" alt="spinner" class="spinner">
                    <span v-else-if='pp[ phase.id ].skipped == 1' class="icon icon-x"></span>
                    <span v-else-if='pp[ phase.id ] && pp[ phase.id ].status == 1 && pp[ phase.id ].user_id' class="icon icon-check"></span>
                    <span v-else-if='pp[ phase.id ] && pp[ phase.id ].status == 1' class="icon icon-alert-octagon"></span>
                    <span v-else class="number">{{ i+1 }}.</span>
                </span>

                <h4 :class="['timeline-item', { active : $parent.phase.id == phase.id } ]">
                    <span @click='setPhase(phase)' class="close-timeline">
                        {{ phase.name }}
                    </span>
                    
                    <span title="Какво е това?" class="open-desc collapsed" data-toggle="collapse" 
                    :href='"#etap-" + (i+1)' role="button" aria-expanded="false" :aria-controls="'etap-' + (i+1)">
                        <span class="icon-plus-circle"></span>
                        <span class="icon-minus-circle"></span>
                    </span>
                </h4>

                <div class="collapse timeline-item-desc" :id="'etap-' + (i+1)">
                    <p v-html='phase.desc'></p>
                </div>

                <span @click='setPhase(phase)' 
                    :class='["vue-link box", { active : $parent.page == "auction"}]' >
                        <span class="text close-timeline">Виж този етап</span>
                        <span class="icon icon-after icon-chevron-right"></span>
                </span>

            </li>

            <li>
                <span class="timeline-step">
                    <span class="number">{{ phases.length + 1 }}.</span>
                </span>

                <h4 @click='projectTP' 
                    :class="['timeline-item', { active : $parent.page == 'project-tp' } ]">
                    <span class="close-timeline"> Тръжни процедури </span>
                    <span title="Какво е това?" class="open-desc collapsed" data-toggle="collapse" 
                    href='#phase-end' role="button" aria-expanded="false" aria-controls="phase-end">
                        <span class="icon-plus-circle"></span>
                        <span class="icon-minus-circle"></span>
                    </span>
                </h4>

                <div class="collapse timeline-item-desc" id="phase-end">
                    Тръжни процедури стартирани от ръководителя на проекта
                </div>

                <span @click='$parent.setPage("project-tp")'
                    :class='["vue-link box", { active : $parent.page == "auction"}]' >
                        <span class="text close-timeline">Виж този етап</span>
                        <span class="icon icon-after icon-chevron-right"></span>
                </span>

            </li>


            <li v-if='user.id == $parent.model.user_id'>
                <span class="timeline-step">
                    <img v-if='$parent.model.finished == 0' 
                         src="/resources/images/spinner.svg" 
                         alt="spinner" class="spinner">
                    <span v-else class="icon icon-check"></span>
                    <span v-else class="number">{{ phases.length + 2 }}.</span>
                </span>

                <h4 @click='projectFinish' 
                    :class="['timeline-item', { active : $parent.page == 'project-finish' } ]">
                    <span class="close-timeline"> Издаване </span>
                    <span title="Какво е това?" class="open-desc collapsed" data-toggle="collapse" 
                    href='#phase-end' role="button" aria-expanded="false" aria-controls="phase-end">
                        <span class="icon-plus-circle"></span>
                        <span class="icon-minus-circle"></span>
                    </span>
                </h4>

                <div class="collapse timeline-item-desc" id="phase-end">
                    Завършване на проекта.
                </div>

                <span @click='$parent.setPage("project-finish")'
                    :class='["vue-link box", { active : $parent.page == "auction"}]' >
                        <span class="text close-timeline">Виж този етап</span>
                        <span class="icon icon-after icon-chevron-right"></span>
                </span>

            </li>

        </ol> 

    </div>

    <div v-if='!isReady' class="d-flex justify-content-center">
        <img src='/resources/loader.svg'>
    </div>

</div>

</template>

<script>
    export default {

        mounted() {

            this.getPhaseData();

            var me = this;

            //After a phase update, refresh component data
            bus.$on('update-phase', ( phase ) => {
                
                me.pp[ me.$parent.projectPhase.phase_id ] = Object.assign({}, me.pp[ me.$parent.projectPhase.phase_id ], phase);
                me.pp = Object.assign({}, me.pp);

            })
        },

        created() {

        },

        data() {
            return {
                isReady : false,
                phases  : [],

                //PhaseID => False or Project phase
                pp : {},

                finished : [],
                projectPhases : false,
                currentPhase : false
            }
        },

        methods : {

            getPhaseData() {
                var me = this;

                me.ajax.call('prj:gph', { id : this.$parent.model.id }, (r) => {
                    
                    if( r.status == 'success' ) {

                        me.projectPhases = r.data.project;
                        me.phases    = r.data.phases;
                        
                        me.$store.state.phases  = r.data.phases;
                        me.$store.state.coefs   = r.data.c;
                        me.$store.state.a   = r.data.a;
                        me.$store.state.b   = r.data.b;

                        me.$store.state.ip = {
                            cost : me._cf.costIP( r.data.a, r.data.b, r.data.c ),
                            time : me._cf.timeIP( r.data.a, r.data.b, r.data.c ),
                            detiled : me._cf.costIP( r.data.a, r.data.b, r.data.c, true)
                        };
                        
                        me.initPhases();

                        me.$nextTick( () => {
                            me.checkHash();
                        });

                    }

                })
            },

            projectFinish() {
                
                this.$parent.setPage("project-finish");

                bus.$emit('set-title','Издаване');

            },

            projectTP() {
                
                this.$parent.setPage("project-tp");

                bus.$emit('set-title','Тръжни процедури');

            },

            //Change phase page, do a check for availability
            setPhase( phase ) {
                var projectPhase = this.getProjectPhase( phase );

                if( this.currentPhase.id != phase.id ) {
                    //Check if this phase is done, if not - restrict access to it.

                    if( !projectPhase ) {
                        
                        $.notify('Тази фаза все още не е достъпна.','warning');

                        return false;
                    }
                }

                this.$parent.setPhase( phase, projectPhase );

                bus.$emit("set-title", phase.name );

                location.hash = phase.code;
            },

            /* 
             * After the data pull, initiate variables
             */
            initPhases() {

                for( var i in this.phases ) {
                    this.pp[ this.phases[i].id ] = false;
                }

                for( var i in this.projectPhases ) {

                    this.pp[ this.projectPhases[i].phase_id ] = this.projectPhases[i];

                    if( this.projectPhases[i].status == 0 ) {
                    
                        this.currentPhase = this.phases.find( x => x.id == this.projectPhases[i].phase_id );
                    
                    } else if( this.projectPhases[i].status == 1 && this.projectPhases[i].user_id ) {

                        this.finished.push( this.projectPhases[i].phase_id );

                    } else if( this.projectPhases[i].skipped == 1 ) {

                        this.finished.push( this.projectPhases[i].phase_id );

                    } 

                }

                //Display the prepared sidebar
                this.isReady = true;
            },

            getProjectPhase( phase ) {
                return this.pp[ phase.id ];
            },

            getPhaseClass( phase ) {
                var projectPhase = this.getProjectPhase( phase );

                if( projectPhase ) {

                    //Phase has a winner and is finished
                    if( projectPhase.status == 1 ) {
                        return 'step-finished';
                    }

                }
             
                return this.currentPhase.id == phase.id ? 'step-inprogress' : 'step-upcoming'

            },


            checkHash() {

                var code = location.hash;

                if( code ) {
                    code = code.replace('#','');
                }

                for( var i in this.phases ) {
                
                    if( this.phases[i].code == code ) {

                        this.setPhase( this.phases[i] );

                    }
                
                }

            },

        }

    }
</script>
